module.exports = __webpack_public_path__ + "static/media/login-mobile-landscape-button.379d749d.svg";